import * as React from "react";
import { MenuItem, Spinner } from "@chakra-ui/react";
import { IoArchiveOutline } from "react-icons/io5";
import { CaseStatusEnum } from "requests";
import { hooks } from "../../duck";

interface ArchiveProps {
  onSuccess(): void;
}

const Archive: React.FC<ArchiveProps> = ({ onSuccess }) => {
  const { update, loading } = hooks.useUpdateStatus(onSuccess);

  return (
    <MenuItem
      color="gray.900"
      fontSize="sm"
      icon={
        loading ? (
          <Spinner width="12px" height="12px" />
        ) : (
          <IoArchiveOutline size="12px" />
        )
      }
      onClick={() => update(CaseStatusEnum.Archived)}
    >
      Archive
    </MenuItem>
  );
};

export default Archive;
